const $fundraisingOrganizationUnorderedList = $('[data-js-fundraising-organization-list]');
const $fundraisingOrganizationDropdown = $('[data-js-fundraising-organization-select]');
const $fundraisingOrganizationWidget = $('[data-js-fundraising-sidebar-widget]');

/**
 * Sort alphabetically
 * @param a
 * @param b
 * @return {number}
 */
const sortAlphabetical = (a, b) => {
  const aText = a.innerText.trim().toLowerCase();
  const bText = b.innerText.trim().toLowerCase();
  return aText.localeCompare(bText);
};

/**
 * sort based on display order
 * @param a
 * @param b
 * @return {number}
 */
const sortCustomDisplayOrder = (a, b) => {
  const aOrder = a.getAttribute('data-display-order');
  const bOrder = b.getAttribute('data-display-order');
  return aOrder - bOrder;
};

$(() => {
  // if the organization display type is alphabetical, rearrange the charity order
  if (window.RR.organizationDisplayTypeIsAlphabetical) {
    // Show fundraising organizations individual widget
    if (window.RR.showFundraisingOrganizationWidgetSidebarWidget) {
      const featuredOrganizations = $fundraisingOrganizationWidget
        .first()
        .children("[data-featured='true']");

      const notFeaturedOrganizations = $fundraisingOrganizationWidget
        .first()
        .children("[data-featured='false']");

      // Sort the featured fundraising organizations based on the display type selected
      featuredOrganizations.sort(window.RR.featuredOrganizationDisplayTypeIsAlphabetical
        ? sortAlphabetical
        : sortCustomDisplayOrder);

      notFeaturedOrganizations.sort(sortAlphabetical);

      $fundraisingOrganizationWidget
        .append(featuredOrganizations)
        .append(notFeaturedOrganizations);
    }

    // Show fundraising organization list/dropdown widget
    if (!window.RR.showFundraisingOrganizationWidgetSidebarWidget) {
      // Get all the featured fundraising organizations
      const featuredOrganizations = window.RR.showFundraisingOrganizationWidgetAsDropdown
        ? $fundraisingOrganizationDropdown
          .first()
          .children("[data-featured='true']")
        : $fundraisingOrganizationUnorderedList
          .first()
          .children("[data-featured='true']");

      // Get all the fundraising organizations which are not featured
      const notFeaturedOrganizations = window.RR.showFundraisingOrganizationWidgetAsDropdown
        ? $fundraisingOrganizationDropdown
          .first()
          .children("[data-featured='false']")
        : $fundraisingOrganizationUnorderedList
          .first()
          .children("[data-featured='false']");

      // Sort the featured fundraising organizations based on the display type selected
      featuredOrganizations.sort(window.RR.featuredOrganizationDisplayTypeIsAlphabetical
        ? sortAlphabetical
        : sortCustomDisplayOrder);

      notFeaturedOrganizations.sort(sortAlphabetical);

      $fundraisingOrganizationUnorderedList.empty();

      const $fundraisingOrganizationList = window.RR.showFundraisingOrganizationWidgetAsDropdown
        ? $fundraisingOrganizationDropdown
        : $fundraisingOrganizationUnorderedList.first();

      $fundraisingOrganizationList
        .append(featuredOrganizations)
        .append(notFeaturedOrganizations);
    }
  }
});
